// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IPublicMyHomeV1UpdateUserStatusRequest,
  TPublicMyHomeV1UpdateUserStatusModel,
  IMappers,
  TPublicMyHomeV1UpdateUserStatusResponse,
  IPublicMyHomeV1UpdateUserStatusResponse,
  IPublicMyHomeV1UpdateUserStatusResponseError,
} from './types';

export const defaultConfig: TPublicMyHomeV1UpdateUserStatusModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/my-home/v1/update-user-status/',
  requestType: 'json',
} as TPublicMyHomeV1UpdateUserStatusModel;

export function createPublicMyHomeV1UpdateUserStatusModel(
  parameters: IPublicMyHomeV1UpdateUserStatusRequest,
): TPublicMyHomeV1UpdateUserStatusModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicMyHomeV1UpdateUserStatusOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicMyHomeV1UpdateUserStatusRequest;
}

export async function fetchPublicMyHomeV1UpdateUserStatus<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicMyHomeV1UpdateUserStatusOptions<TResponse200, TResponse400>): Promise<
  TPublicMyHomeV1UpdateUserStatusResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createPublicMyHomeV1UpdateUserStatusModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicMyHomeV1UpdateUserStatusResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IPublicMyHomeV1UpdateUserStatusResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicMyHomeV1UpdateUserStatusResponse;
}
